/**
 * Hook to manage first-run onboarding state.
 * Uses localStorage to persist completion.
 */

import { useState, useCallback } from 'react';

const STORAGE_KEY = 'peekbox_onboarding_complete';

export interface UseOnboardingReturn {
  /** Whether the onboarding wizard should be shown */
  shouldShow: boolean;
  /** Mark onboarding as complete (hides wizard, persists to localStorage) */
  complete: () => void;
}

export function useOnboarding(): UseOnboardingReturn {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  const complete = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // Storage unavailable; dismiss for this session only
    }
    setDismissed(true);
  }, []);

  return {
    shouldShow: !dismissed,
    complete,
  };
}
